import { gql } from '@apollo/client';

export const CREATE_METER = gql`
  mutation Flex_CreateMeter($input: CreateMeterInput!) {
    meter: createMeter(input: $input) {
      id
      meterNumber
      serviceType
      utilityAccountId
      utilityId
    }
  }
`;
